import type { CorbanOption } from "@hooks/useCorbansOptions";
import { PRODUCT_TYPE } from "@utils/enums";

/** Corban usado pelo login temporário do PaGoal em desenvolvimento local. */
export const pagoalMockCorban: CorbanOption = {
  id: 1,
  corban_name: "PaGoal",
  fantasy_name: "PaGoal",
  name: "PaGoal",
  url: "http://localhost:5173",
  produtos: [
    {
      nome: "Consignado",
      tipo_produto: PRODUCT_TYPE.CONSIGNADO,
    },
  ],
};

const base64Url = (value: object) =>
  btoa(JSON.stringify(value))
    .replace(/=+$/, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");

/**
 * Sessão local sem assinatura, válida apenas para navegar no front em
 * desenvolvimento. Nenhuma API real aceita esse token.
 */
export const createPagoalMockSession = (identifier: string) => {
  const issuedAt = Math.floor(Date.now() / 1000);
  const token = [
    base64Url({ alg: "none", typ: "JWT" }),
    base64Url({ sub: "pagoal-local", iat: issuedAt, exp: issuedAt + 8 * 3600 }),
    "local",
  ].join(".");

  return {
    accessToken: token,
    refreshToken: token,
    identifier,
    name: "Usuário PaGoal",
    products: {
      [PRODUCT_TYPE.CONSIGNADO]: "Consignado Público",
    },
    corbanId: pagoalMockCorban.id,
    corbanName: pagoalMockCorban.name,
    tokenHasDataOfCorbanId: pagoalMockCorban.id,
  };
};
